// FL-01 · Caderno da Obra — PDF por obra, folhas de 24 linhas, modelo do Regimento (rev.02)
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";

const NAVY = [16, 42, 74];
const GOLD = [201, 168, 76];
const TEXT = [30, 41, 59];
const MUTED = [100, 116, 139];
const BORDER = [180, 188, 200];
const PW = 297; // paisagem
const M = 10;

const fData = (s) => (s ? new Date(String(s).slice(0, 10) + "T00:00:00").toLocaleDateString("pt-BR") : "");

function desenharFolha(doc, obraTitulo, folha, linhas, porFolha) {
  doc.setFillColor(...NAVY).rect(0, 0, PW, 14, "F");
  doc.setFillColor(...GOLD).rect(0, 14, PW, 1, "F");
  doc.setTextColor(255, 255, 255).setFont("helvetica", "bold").setFontSize(11);
  doc.text("FL-01 · Caderno da Obra", M, 7);
  doc.setFontSize(6.5).setFont("helvetica", "normal").setTextColor(220, 225, 235);
  doc.text("OBRASUL · Um Show de Obra · Legenda tipo: E entrega · D devolução · OF faltante · OA avariado · OE item errado · OS esquecido na base", M, 11);
  doc.setFont("helvetica", "bold").setFontSize(9).setTextColor(...GOLD);
  doc.text(`Folha ${folha}`, PW - M, 7, { align: "right" });
  doc.setFontSize(7).setTextColor(220, 225, 235).setFont("helvetica", "normal");
  doc.text(String(obraTitulo || ""), PW - M, 11, { align: "right" });

  const corpo = linhas.map((l) => [
    l.linha_folha, fData(l.data), l.tipo || "", l.num_ref || "", l.item || "", l.unidade || "",
    l.qtd_enviada ?? "", l.qtd_recebida ?? "", l.conf || "", l.no_sistema ? "X" : "", l.recebido_por || "", ""]);
  while (corpo.length < porFolha) corpo.push([corpo.length + 1, "", "", "", "", "", "", "", "", "", "", ""]);

  autoTable(doc, {
    startY: 18,
    margin: { left: M, right: M },
    head: [["Nº", "Data", "Tipo", "Nº req./rom.", "Item", "Unid.", "Qtd. env.", "Qtd. rec.", "Conf. OK/DIV", "No sist. (X)", "Recebido por", "Rubrica Log."]],
    body: corpo,
    theme: "grid",
    styles: { fontSize: 6.2, cellPadding: 0.9, textColor: TEXT, lineColor: BORDER, lineWidth: 0.15, minCellHeight: 4.6 },
    headStyles: { fillColor: NAVY, textColor: [255, 255, 255], fontSize: 6, halign: "center", cellPadding: 1 },
    columnStyles: {
      0: { cellWidth: 8, halign: "center" }, 1: { cellWidth: 17, halign: "center" }, 2: { cellWidth: 11, halign: "center" },
      3: { cellWidth: 24 }, 4: { cellWidth: 72 }, 5: { cellWidth: 11, halign: "center" },
      6: { cellWidth: 14, halign: "center" }, 7: { cellWidth: 14, halign: "center" }, 8: { cellWidth: 17, halign: "center" },
      9: { cellWidth: 15, halign: "center" }, 10: { cellWidth: 38 }, 11: { cellWidth: "auto" },
    },
    didParseCell: (d) => {
      if (d.section === "body" && d.column.index === 8 && d.cell.raw === "DIV") {
        d.cell.styles.textColor = [185, 28, 28];
        d.cell.styles.fontStyle = "bold";
      }
    },
  });
  let y = doc.lastAutoTable.finalY + 3;

  // quadro de ocorrencias da folha
  doc.setFont("helvetica", "bold").setFontSize(7.5).setTextColor(...NAVY);
  doc.text("QUADRO DE OCORRÊNCIAS DA FOLHA (preenchido pelo Líder/Logística para cada linha DIV/O)", M, y);
  y += 1.5;
  const ocs = linhas.filter((l) => l.ocorrencia).map((l) => [
    l.linha_folha, l.ocorrencia.o_que_aconteceu || "", l.ocorrencia.parou_equipe ? "S" : "N",
    `${l.ocorrencia.providencia || ""}${l.ocorrencia.prazo ? " · prazo " + fData(l.ocorrencia.prazo) : ""}`]);
  while (ocs.length < 3) ocs.push(["", "", "", ""]);
  autoTable(doc, {
    startY: y,
    margin: { left: M, right: M },
    head: [["Linha nº", "O que aconteceu e causa", "Parou equipe? S/N", "Providência e prazo"]],
    body: ocs,
    theme: "grid",
    styles: { fontSize: 6.2, cellPadding: 1, textColor: TEXT, lineColor: BORDER, lineWidth: 0.15, minCellHeight: 4.8 },
    headStyles: { fillColor: [71, 85, 105], textColor: [255, 255, 255], fontSize: 6, halign: "center" },
    columnStyles: { 0: { cellWidth: 16, halign: "center" }, 1: { cellWidth: 120 }, 2: { cellWidth: 28, halign: "center" }, 3: { cellWidth: "auto" } },
  });
  y = doc.lastAutoTable.finalY + 7;

  const aw = (PW - 2 * M - 20) / 2;
  ["Líder da obra", "Logística"].forEach((lbl, i) => {
    const x = M + i * (aw + 20);
    doc.setDrawColor(...TEXT).setLineWidth(0.25).line(x, y + 6, x + aw, y + 6);
    doc.setFontSize(6).setTextColor(...MUTED);
    doc.text(lbl, x + aw / 2, y + 9, { align: "center" });
  });

  doc.setFillColor(...NAVY).rect(0, 202, PW, 8, "F");
  doc.setFontSize(6.5).setTextColor(255, 255, 255);
  doc.text("OBRASUL · Um Show de Obra · Registro físico obrigatório · FL-01 · rev.02", PW / 2, 207, { align: "center" });
}

export function gerarFL01PDF({ obraTitulo, linhas, linhasPorFolha = 24 }) {
  const doc = new jsPDF({ unit: "mm", format: "a4", orientation: "landscape", compress: true });
  const folhas = [...new Set(linhas.map((l) => l.folha))].sort((a, b) => a - b);
  (folhas.length ? folhas : [1]).forEach((f, i) => {
    if (i > 0) doc.addPage();
    desenharFolha(doc, obraTitulo, f, linhas.filter((l) => l.folha === f), linhasPorFolha);
  });
  doc.save(`FL-01_Caderno_${String(obraTitulo || "obra").replace(/[^a-zA-Z0-9-_]+/g, "_").slice(0, 30)}.pdf`);
}
